import { createContext } from 'react'

import { SmartGetEnvironment_getEnvironmentBySlug } from 'src/smart/queries/types/SmartGetEnvironment'

export type IEnvironment = SmartGetEnvironment_getEnvironmentBySlug

export const EnvironmentContext = createContext<IEnvironment | undefined>(undefined)
export const RefetchEnvironmentContext = createContext<() => void | undefined>(undefined)
